export default "__VITE_ASSET__CGModt1n__"